import {
  HOMEPAGE_FEATURED_CONTENT_SUCCESS,
  HOMEPAGE_FEATURED_CONTENT_FAILURE,
  HOMEPAGE_FILTER_SELECTED,
  HOMEPAGE_FILTER_CLEAR,
  HOMEPAGE_HERO_CUISINE_IMAGE,
  HOMEPAGE_HERO_SHAPE_COLOR,
} from '../actions/types';

const initialState = {
  collections: [],
  restaurants: [],
  landingPages: [],
};

export default function homepageFeaturedContentReducer(state = initialState, action = {}) {
  switch (action.type) {
    case HOMEPAGE_FEATURED_CONTENT_SUCCESS:
      return {
        ...state,
        collections: action.payload.data.collection_tags.map((collection) => ({
          id: collection.uname,
          name: collection.name,
          description: collection.description,
          image: collection.image,
        })),
        restaurants: action.payload.data.featured_menu_groups.map((restaurant) => ({
          id: restaurant.uname,
          name: restaurant.name,
          description: restaurant.description,
          image: restaurant.image,
        })),
        landingPages: action.payload.data.campaign_landing_page_tags.map((tag) => ({
          id: tag.uname,
          name: tag.title,
          href: tag.href,
        })),
      };
    case HOMEPAGE_FEATURED_CONTENT_FAILURE:
      return {
        ...state,
        error: {
          status: action.status,
        },
      };

    case HOMEPAGE_FILTER_SELECTED:
      return {
        ...state,
        filter: action.payload,
      };

    case HOMEPAGE_FILTER_CLEAR:
      return {
        ...state,
        filter: null,
      };
    case HOMEPAGE_HERO_CUISINE_IMAGE:
      return {
        ...state,
        heroCuisineImage: action.payload.heroCuisineImage,
      };
    case HOMEPAGE_HERO_SHAPE_COLOR:
      return {
        ...state,
        heroShapeColor: action.payload.heroShapeColor,
      };

    default:
      return state;
  }
}
